import React from 'react';
import { useMyTripsData } from '../../hooks/myTrips/useMyTripsData';
import { useCreateTripModal } from '../../hooks/myTrips/useCreateTripModal';
import { MyTripsHeader } from './MyTripsHeader';
import { MyTripsGrid } from './MyTripsGrid';
import { CreateTripModal } from './CreateTripModal';

/**
 * My Trips page component - refactored to separate business logic from UI.
 * All business logic is now in custom hooks, making it reusable for React Native.
 */
export const MyTripsPage = React.memo(() => {
  // Business logic hooks (platform-agnostic)
  const { trips, isLoading, latestTrip, latestTripHref, heroImage, hasTrips } = useMyTripsData();
  const {
    isModalOpen,
    openModal,
    closeModal,
    title,
    setTitle,
    startDate,
    endDate,
    handleDateChange,
    createTrip,
    isLoading: isCreatingTrip,
    isFormValid,
  } = useCreateTripModal();

  return (
    <div className="min-h-screen bg-subtle">
      <MyTripsHeader
        heroImage={heroImage}
        isLoading={isLoading}
        latestTripTitle={latestTrip?.title}
        onCreateTrip={openModal}
        isCreatingTrip={isCreatingTrip}
        continueHref={latestTripHref}
      />

      <MyTripsGrid
        trips={trips}
        isLoading={isLoading}
        hasTrips={hasTrips}
        onCreateTrip={openModal}
        isCreatingTrip={isCreatingTrip}
      />

      <CreateTripModal
        isOpen={isModalOpen}
        onClose={closeModal}
        title={title}
        onTitleChange={setTitle}
        startDate={startDate}
        endDate={endDate}
        onDateChange={handleDateChange}
        onCreateTrip={createTrip}
        isLoading={isCreatingTrip}
        isFormValid={isFormValid}
      />
    </div>
  );
});
